import React, { useEffect, useRef } from "react";
import {
  StyleSheet,
  View,
  Dimensions,
  Animated,
  TouchableOpacity,
  Easing,
} from "react-native";
import "../../../../App.scss";
import CustomCard from "./CustomCard";
import { withRouter } from "react-router-dom";

export const dotColor = "#495049";
export const customDimesion = Dimensions.get("window").width;
const actualWidth = Dimensions.get("screen").width;

const Index = (props) => {
  const firstCardAnimation = useRef(
    new Animated.Value(-Dimensions.get("window").height / 2)
  ).current;

  useEffect(() => {
    if (props.flow === "dow") {
      firstCardAnimation.setValue(-Dimensions.get("window").height / 2);
      Animated.timing(firstCardAnimation, {
        toValue: 1,
        duration: 400,
        useNativeDriver: false,
        easing: Easing.linear,
      }).start(() => {
        setTimeout(() => props.setRestrict(false), 200);
      });
    }
    if (props.flow === "up") {
      firstCardAnimation.setValue(1);
      Animated.timing(firstCardAnimation, {
        toValue: -Dimensions.get("window").height / 2,
        duration: 400,
        useNativeDriver: false,
        easing: Easing.linear,
      }).start(() => {
        props.selectAnswerHandler(
          props.moduleObject.moduleid,
          props.Questions[props.indexOfset].qid,
          props.Questions[props.indexOfset].answers[props.answerId].respid
        );
        props.setIndexOfset((prev) => prev + 1);
        props.navigation(props.answerId);
        setTimeout(() => props.setRestrict(false), 200);
      });
    }
  }, []);

  return (
    <View style={styles.cardsContainer}>
      <Animated.View
        style={[
          styles.firstcard,
          { transform: [{ translateY: firstCardAnimation }] },
        ]}
      >
        <View style={styles.firstThread} />
        <TouchableOpacity
          style={{ height: "65%", width: "100%" }}
          disabled={true}
        >
          {
            <CustomCard
              style={styles.customStyle}
              data={props.Questions[props.indexOfset].text}
              innerStyle={styles.innerStyleFirst}
              valueStyle={styles.valueStyleFirst}
              thread="first"
            />
          }
        </TouchableOpacity>
        <div
          className={
            customDimesion > 600
              ? "firstCardShadow"
              : customDimesion > 405
              ? "firstCardShadow1"
              : "firstCardShadow2"
          }
        />
      </Animated.View>
    </View>
  );
};

export default withRouter(Index);

const styles = StyleSheet.create({
  cardsContainer: {
    height: "50%",
    width: "65%",
    alignSelf: "center",
    elevation: 10,
    position: "absolute",
    top: -20,
  },
  firstcard: {
    position: "relative",
    zIndex: 3,
    width: "100%",
    height: "90%",
  },

  firstThread: {
    position: "relative",
    borderLeftColor: "var(--knowledge-question-thread-color)",
    borderRightColor: "var(--knowledge-question-thread-color)",
    borderWidth: 2,
    borderStyle: "solid",
    height: "40%",
    zIndex: 5,
    borderBottomColor: "transparent",
    borderTopColor: "transparent",
    width: "85%",
    alignSelf: "center",
  },

  customStyle: {
    position: "relative",
    marginTop: -10,
    backgroundColor: "var(--module-color-obj)",
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    marginVertical: 40,
    padding: 15,
  },
  innerStyleFirst: {
    position: "relative",
    width: "100%",
    textAlign: "center",
    color: "var(--module-overlay-text-color-obj)",
    fontFamily: "var(--font-family-default)",
    fontSize: actualWidth <= 320 ? 16 : 23,
    letterSpacing: actualWidth <= 320 ? 1.6 : "normal",
  },
});
